import { Box, styled, Typography } from '@mui/material'

export const Input = styled('input')(() => ({
  opacity: 0,
  height: '100%',
  width: '100%',
}))

export const UploadArea = styled(Box)(() => ({
  border: '3px dashed #EEEEEE',
  borderRadius: '4px',
  margin: '24px',
  padding: '16px 0',
  position: 'relative',
  textAlign: 'center',
}))

export const UploadTextArea = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

export const UploadText = styled(Typography)(() => ({
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.15px',
  color: '#000000',
}))

export const ImageDropZone = {
  position: 'absolute',
  width: '100%',
  top: 0,
  flex: 1,
  display: 'flex',
  height: '136px',
  flexDirection: 'column',
  alignItems: 'center',
  borderStyle: 'dashed',
  color: '#D4D4D4',
}
